import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ConfirmSaveYesNoOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ConfirmSaveYesNoOverlayDialog');
    }
	handleYes(event) {
		this.props.updateOrderStatus('Save', 'showConfirmSaveYesNoOverlayDialog');
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmSaveYesNoOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Confirm Enter</h2>
                    <p className="red bold">Product Inventory is NOT reserved on ENTERED orders. Available Backorders CAN expire on an ENTERED order. ENTERED orders will not ship.</p>
					<p className="red bold">If this order is complete and ready to ship, please cancel this and BOOK the order.</p>
                    <p>Do you want to continue?</p>
                    <div className="noButtonContainer">
                        <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
         	            <a className="yesButton blueButton" onClick={this.handleYes.bind(this)}>Continue</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ConfirmSaveYesNoOverlayDialog = connect(mapStateToProps)(ConfirmSaveYesNoOverlayDialog);
export default ConfirmSaveYesNoOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmSaveYesNoOverlayDialog.js